module.exports = __webpack_public_path__ + "img/mdm-deploy-4.006497d9.webp";